import http from './http';
import {BOARD_BASE} from './paths';
import {withPerm} from './perm';

export const searchBoardPosts = withPerm(async (params = {}) => {
  const response = await http.get(`${BOARD_BASE}/posts`, { params });
  return response.data;
}, 'GET', `${BOARD_BASE}/posts`);

export const getBoardPost = withPerm(async (boardPostId) => {
  const response = await http.get(`${BOARD_BASE}/posts/${boardPostId}`);
  return response.data;
}, 'GET', `${BOARD_BASE}/posts/{boardPostId}`);

export const createBoardPost = withPerm(async (payload) => {
  const response = await http.post(`${BOARD_BASE}/posts`, payload);
  return response.data;
}, 'POST', `${BOARD_BASE}/posts`);

export const updateBoardPost = withPerm(async (boardPostId, payload) => {
  const response = await http.put(`${BOARD_BASE}/posts/${boardPostId}`, payload);
  return response.data;
}, 'PUT', `${BOARD_BASE}/posts/{boardPostId}`);

export const deleteBoardPost = withPerm(async (boardPostId) => {
  const response = await http.delete(`${BOARD_BASE}/posts/${boardPostId}`);
  return response.data;
}, 'DELETE', `${BOARD_BASE}/posts/{boardPostId}`);

export const increaseViewCount = withPerm(async (boardPostId) => {
  const response = await http.post(`${BOARD_BASE}/posts/${boardPostId}/view`);
  return response.data;
}, 'POST', `${BOARD_BASE}/posts/{boardPostId}/view`);

export const recommendBoardPost = withPerm(async (boardPostId) => {
  const response = await http.post(`${BOARD_BASE}/posts/${boardPostId}/recommend`);
  return response.data;
}, 'POST', `${BOARD_BASE}/posts/{boardPostId}/recommend`);

export const listBoardPostComments = withPerm(async (boardPostId) => {
  const response = await http.get(`${BOARD_BASE}/posts/${boardPostId}/comments`);
  return response.data;
}, 'GET', `${BOARD_BASE}/posts/{boardPostId}/comments`);

export const createBoardPostComment = withPerm(async (boardPostId, payload) => {
  const response = await http.post(`${BOARD_BASE}/posts/${boardPostId}/comments`, payload);
  return response.data;
}, 'POST', `${BOARD_BASE}/posts/{boardPostId}/comments`);

export const deleteBoardPostComment = withPerm(async (boardPostId, boardPostCommentId) => {
  const response = await http.delete(`${BOARD_BASE}/posts/${boardPostId}/comments/${boardPostCommentId}`);
  return response.data;
}, 'DELETE', `${BOARD_BASE}/posts/{boardPostId}/comments/{boardPostCommentId}`);
